<template>
  <v-dialog :value="value" :width="firstStep ? '480px' : '800px'" @input="$emit('input', false)">
    <v-card v-if="firstStep" class="first-step">
      <v-card-text class="pa-5">
        <h3 class="mb-5 step-title">Qual será o nome do número?</h3>
        <v-text-field v-model="number.name" placeholder="Digite um nome... (opcional)" outlined counter="50" />

        <v-tooltip bottom nudge-left="100px" max-width="250px">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-checkbox
                v-model="numberSendsCampaigns"
                class="mt-0 checkbox"
                color="primary"
                label="Número dispara campanhas"
                hide-details
                @change="number.send_welcome_on_import = false"
              />
            </span>
          </template>
          <span
            >Marque para números que serão utilizados para enviar campanhas. Esta opção deve ser desmarcada quando o número a ser configurado será utilizado
            como roteador para outros números.</span
          >
        </v-tooltip>

        <v-checkbox
          v-model="number.import_contacts"
          :disabled="!numberSendsCampaigns"
          class="checkbox"
          color="primary"
          label="Importar contatos do histórico"
          hide-details
          @change="number.send_welcome_on_import = false"
        />

        <v-checkbox
          v-model="number.send_welcome_on_import"
          :disabled="!number.import_contacts"
          color="primary"
          class="checkbox"
          label="Enviar mensagem de Boas-vindas durante a importação"
          hide-details
        />
        <v-text-field v-if="isAdmin" v-model="wappInstanceId" label="Instance ID" class="mt-3" outlined />

        <mf-action-buttons
          :primary-button="{
            text: 'Salvar e continuar',
            action: nextStep,
            isLoading: nextStepLoading,
            isVisible: true,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: cancel,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
    <v-card v-else class="dialog-ativar-numero">
      <v-card-text style="padding: 16px">
        <v-container class="pa-0" fluid fill-height>
          <v-row justify="center">
            <v-col cols="5" align="center" justify="center">
              <v-progress-circular v-if="$apollo.loading" class="loader" indeterminate color="primary" />
              <qrcode v-else-if="!$apollo.loading && qrCode" :value="qrCode" :options="{ width: 200 }" />
            </v-col>
            <v-col cols="7">
              <h3 class="ativar-title">Para finalizar a ativação e configuração do seu número, por favor escaneie o QR Code ao lado:</h3>

              <p>1. Abra o WhatsApp no celular</p>
              <p>
                2. Toque no <strong>Menu</strong> <mf-icon color="primary">more_vert</mf-icon> ou <strong>Configurações</strong>
                <mf-icon color="primary">settings_applications</mf-icon> e selecione o WhatsApp Web
              </p>
              <p>3. Aponte o celular para essa tela e mire no <strong>QR code</strong></p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag'
import { wsClientHulk } from '@/services/webSocket'

const SUBSCRIPTION_QRCODE_UPDATED = gql`
  subscription ($request_id: String!) {
    QRCodeUpdated(request_id: $request_id) {
      request_id
      qrcode
      qrcode_scanned
    }
  }
`

const MUTATION_ADD_NUMBER = gql`
  mutation AddNumber($instance_id: ID, $number_type: NumberTypes, $name: String, $import_contacts: Boolean!, $send_welcome_on_import: Boolean) {
    addNumber(
      instance_id: $instance_id
      number_type: $number_type
      name: $name
      import_contacts: $import_contacts
      send_welcome_on_import: $send_welcome_on_import
    ) {
      request_id
      qrcode
    }
  }
`

export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    qrCode: '',
    nextStepLoading: false,
    requestId: '',
    firstStep: true,
    numberSendsCampaigns: true,
    wappInstanceId: null,
    number: {
      name: '',
      import_contacts: true,
      send_welcome_on_import: false,
    },
  }),
  computed: {
    isAdmin() {
      return this.$getIsAdmin()
    },
  },
  watch: {
    value(event) {
      if (!event) {
        this.$destroy()
      }
    },
    numberSendsCampaigns(val) {
      if (!val) {
        this.number.import_contacts = false
        this.number.send_welcome_on_import = false
      }
    },
  },
  methods: {
    async nextStep() {
      this.nextStepLoading = true
      try {
        const { data } = await this.$apollo.mutate({
          mutation: MUTATION_ADD_NUMBER,
          variables: {
            instance_id: this.wappInstanceId,
            name: this.number.name,
            import_contacts: this.number.import_contacts,
            send_welcome_on_import: this.number.send_welcome_on_import,
            number_type: this.numberSendsCampaigns ? 'SENDER' : 'ROUTER',
          },
        })

        this.qrCode = data.addNumber.qrcode
        this.requestId = data.addNumber.request_id
        this.createSubscription(this.requestId)
        this.firstStep = false
      } catch (e) {
        console.log(e)
        this.$snackbar({ message: 'Erro ao adicionar número.', snackbarColor: 'error' })
      }
      this.nextStepLoading = false
    },
    async createSubscription(request_id) {
      const self = this
      await wsClientHulk.subscribe(
        {
          query: SUBSCRIPTION_QRCODE_UPDATED,
          operationName: 'QRCodeUpdatedWhatsapp',
          variables: {
            request_id: request_id,
          },
        },
        {
          next({ data }) {
            if (data.QRCodeUpdated.qrcode === 'expired') {
              self.$apollo.queries.qrCode.refetch()
            } else if (data.QRCodeUpdated.qrcode_scanned) {
              self.qrCodeScanned()
            }
            self.$set(self, 'qrCode', data.QRCodeUpdated.qrcode)
          },
          error(error) {
            console.error(error)
          },
        }
      )
    },
    cancel() {
      this.$emit('input', false)
    },
    qrCodeScanned() {
      this.$emit('refresh')
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="scss">
.first-step {
  .step-title {
    opacity: 0.8;
    font-family: Lato;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.22;
    letter-spacing: 0.29px;
    color: $preto;
  }
  .checkbox {
    label {
      opacity: 0.8;
      font-size: 15px;
      line-height: 1.2;
      letter-spacing: 0.24px;
    }
  }
}
.dialog-ativar-numero {
  .ativar-title {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0.33px;
    color: $cinza-d20;
    margin-bottom: 24px;
  }
  p {
    margin-bottom: 12px;
  }
  .loader {
    height: 100% !important;
  }
}
</style>
